var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1686551982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4841 2.16056C11.7947 1.94648 12.2053 1.94648 12.5159 2.16056L21.6067 8.42596C21.8772 8.61236 22.0153 8.91912 21.9987 9.22474C21.9995 9.24064 21.9999 9.25662 21.9999 9.27267V19.1899C21.9999 20.1633 21.2591 21.0907 20.1818 21.0907H3.81825C2.74086 21.0907 2.00008 20.1633 2.00008 19.1899V9.27267C2.00008 9.25662 2.00051 9.24064 2.00134 9.22474C1.98472 8.91913 2.12282 8.61236 2.39328 8.42596L11.4841 2.16056ZM3.81825 10.9478V19.1899C3.81825 19.2324 3.83198 19.2595 3.84194 19.2726H20.1581C20.168 19.2595 20.1818 19.2324 20.1818 19.1899V10.9478L12.4954 15.9439C12.1942 16.1397 11.8058 16.1397 11.5046 15.9439L3.81825 10.9478ZM19.5301 9.2029L12 4.01316L4.46991 9.2029L12 14.0975L19.5301 9.2029Z",
    fill: "#737890"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.07d18c911a57a8bdf5ac4641f59ebac9.svg";
export { ForwardRef as ReactComponent };